import { post_data } from "../helpers/functions";
import toastr_show from "../helpers/toastr_options";

export default class Modal {
  constructor() {
    this.location = location.href.split("projects")[0];
  }
  archive_modal = (name, type, url = false) => {
    return `<div class="modal archive-modal active">
                <div class="modal__heading-container">
                    <h3 class="modal__heading">Archive</h3>
                </div>
                <div class="modal__body">
                    <h4 class="modal__body-heading">Do you want to archive?</h4>
                    <h4 class="modal__body-heading">${type} name: ${name}</h4>
                    <div class="modal__buttons">
                        <a href="${
                          this.location + "editor?id=" + url
                        }" class="btn btn-primary modal__button modal__archive mr-2">Archive</a>
                        <a href="" class="btn modal__button modal__close">Cancel</a>
                    </div>
                </div>
            </div>
            <div class="modal-overlay"></div>`;
  };

  restore_modal = (name, type, url = false) => {
    return `<div class="modal archive-modal restore-modal">
                <div class="modal__heading-container">
                    <h3 class="modal__heading">Restore</h3>
                </div>
                <div class="modal__body">
                    <h4 class="modal__body-heading">Do you want to restore?</h4>
                    <h4 class="modal__body-heading">${type} name: ${name}</h4>
                    <div class="modal__buttons">
                        <a href="${
                          this.location + "editor?id=" + url
                        }" class="btn btn-primary modal__button modal__restore mr-2">Restore</a>
                        <a href="" class="btn modal__button modal__close">Cancel</a>
                    </div>
                </div>
            </div>
            <div class="modal-overlay"></div>`;
  };

  share_modal = (url = "") => {
    return `<div class="modal share-modal">
                <div class="modal__heading-container">
                    <h3 class="modal__heading modal__heading-large">Share</h3>
                </div>
                <div class="modal__body">
                    <h4 class="modal__body-heading">Copy this link</h4>
                    <input type="text" class="modal__body-input" value="${
                      this.location + "editor?id=" + url
                    }" readonly>
                    <div class="modal__buttons">
                        <button class="btn btn-primary modal__button modal__copy mr-2">Copy</button>
                        <button class="btn modal__button modal__close">Cancel</button>
                    </div>
                </div>
              </div>
              <div class="modal-overlay"></div>`;
  };
  add_modal = (buttonText = "Add", value = "", id = "", real_heading = "", data = "") => {
    const buttonClass = buttonText.toLowerCase().replace(/\s+/g, '-');
    let heading = real_heading || (value === "" ? "New file" : "Change project name");
  
    let templateOptions = '';
    if (data) {
      const response = data;
      if (response && Array.isArray(response)) {
        const templateProjects = response.filter(item => item.is_template === '1');
        templateOptions = '<option value="0" selected>Select template</option>';
        templateOptions += templateProjects.map(item => `<option value="${item.id}">${item.name} - Version ${item.version}</option>`).join('');
      }
    }
  
    return `<div class="modal">
              <div class="modal__heading-container">
                <h3 class="modal__heading">${heading}</h3>
              </div>
              <div class="modal__body">
                <input type="text" class="modal__body-input" value="${value != null ? value : ''}" placeholder="Design name">
                ${templateOptions ? `
                  <div class="dropdown-select">
                    <select class="dropdown-select dropdown-select__selected-item template-select">
                      ${templateOptions}
                    </select>
                  </div>
                ` : ''}
              </div>
              <div class="modal__buttons">
                <button class="btn btn-primary modal__button modal__copy mr-2 ${buttonClass}" ${id !== "" ? "data-id=" + id : ""}>${buttonText}</button>
                <button class="btn modal__button modal__close">Cancel</button>
              </div>
            </div>
            <div class="modal-overlay"></div>`;
  };
  
  save_modal = () => {
    return this.add_modal("Save");
  };
  delete_modal = (type, name, id) => {
    const url = !this.location.includes("editor")
      ? this.location + "editor?id=" + id
      : this.location + "&&id=" + id;
    return `<div class="modal delete-modal">
                <div class="modal__heading-container">
                    <h3 class="modal__heading modal__heading-large">Delete</h3>
                </div>
                <div class="modal__body">
                    <h4 class="modal__body-heading">Are you sure you want to delete this ${type}?</h4>
                    <div class="modal__buttons">
                        <button data-id="${url}" class="btn btn-danger modal__button modal__archive modal__delete mr-2" >Delete</button>
                        <button class="btn modal__button modal__close">Cancel</button>
                    </div>
                </div>
              </div>
              <div class="modal-overlay"></div>`;
  };
  delete_additional_image_modal = () => {
    return `<div class="modal delete-modal">
                <div class="modal__heading-container">
                    <h3 class="modal__heading modal__heading-large">Delete</h3>
                </div>
                <div class="modal__body">
                    <h4 class="modal__body-heading">Are you sure you want to delete additional image?</h4>
                    <div class="modal__buttons">
                        <button class="btn btn-danger modal__button mr-2" id="remove-additional-image-button">Delete</button>
                        <button class="btn modal__button modal__close">Cancel</button>
                    </div>
                </div>
              </div>
              <div class="modal-overlay"></div>`;
  };

  leave_editor = (goBack) => {
    const back = goBack ? "to-home-page" : "";
    return `<div class="modal active">
                <div class="modal__heading-container">
                    <h3 class="modal__heading modal__heading--logout">You have unsaved changes. Would you like to save them before leaving the page??</h3>
                </div>
                <div class="modal__body">
                    <h4 class="modal__body-heading">&nbsp;</h4>
                    <div class="modal__buttons modal__buttons--center">
                        <button class="btn btn-primary modal__button save mr-2 save-form ${back}" id="save-form">Save</button>
                        <button href="" class="btn modal__button modal__close ${back}" >Leave</button>
                    </div>
                </div>
            </div>
            <div class="modal-overlay"></div>`;
  };

  logout_modal = () => {
    return `<div class="modal active">
                <div class="modal__heading-container">
                    <h3 class="modal__heading modal__heading--logout">Are you sure you want to exit Sketchform?</h3>
                </div>
                <div class="modal__body">
                    <h4 class="modal__body-heading">&nbsp;</h4>
                    <div class="modal__buttons modal__buttons--center">
                        <button class="btn btn-primary modal__button logout mr-2">Yes</button>
                        <button href="" class="btn modal__button modal__close">Cancel</button>
                    </div>
                </div>
            </div>
            <div class="modal-overlay"></div>`;
  };

  confirm_modal = (message, confirmText = "OK", cancelText = "Cancel") => {
    return `<div class="modal delete-modal">
                <div class="modal__heading-container">
                    <h3 class="modal__heading modal__heading-large">Confirm</h3>
                </div>
                <div class="modal__body">
                    <h4 class="modal__body-heading">${message}</h4>
                    <div class="modal__buttons">
                        <button class="btn btn-primary modal__button mr-2" id="confirm-modal-ok">${confirmText}</button>
                        <button class="btn btn-secondary modal__button" id="confirm-modal-cancel">${cancelText}</button>
                    </div>
                </div>
              </div>
              <div class="modal-overlay"></div>`;
  };

  showConfirm = (message, confirmText = "OK", cancelText = "Cancel") => {
    return new Promise((resolve) => {
      const div = document.createElement("div");
      div.innerHTML = this.confirm_modal(message, confirmText, cancelText);
      document.body.append(div);

      const cleanup = (result) => {
        div.remove();
        resolve(result);
      };

      div.querySelector("#confirm-modal-ok").addEventListener("click", () => cleanup(true));
      div.querySelector("#confirm-modal-cancel").addEventListener("click", () => cleanup(false));
      div.querySelector(".modal-overlay").addEventListener("click", () => cleanup(false));
    });
  };

  projectTypeModal = () => {
    return `<div class="modal">
                <div class="modal__heading-container">
                    <h3 class="modal__heading modal__heading-large">Select design type</h3>
                </div>
                <div class="modal__body">
                    <div class="dropdown-select">
                        <div id="selected-design-type" class="dropdown-select__selected-item" data-id="0">Select design type</div>
                        <ul id="dropdown-select-items" class="dropdown-select__content">
                            <li class="dropdown-select__item" data-id="0"> Select design type </li>
                            <li class="dropdown-select__item" data-id="1"> Forster Kollektion </li>
                            <li class="dropdown-select__item" data-id="4"> Forster Orders </li>
                            <li class="dropdown-select__item" data-id="7"> Forster Lace </li>
                            <li class="dropdown-select__item" data-id="T"> Tests </li>
                            <li class="dropdown-select__item" data-id="J"> Jacob Schläpfer </li>
                            <li class="dropdown-select__item" data-id="A"> Afrika </li>
                            <li class="dropdown-select__item" data-id="manual"> Enter Design Number Manually </li> <!-- New option -->
                        </ul>
                    </div>

                    <!-- Input field for design number (hidden by default) -->
                    <div class="modal__input-container" id="manual-input-container" style="display: none;">
                        <input type="text" class="modal__input" name="design-number" id="design-number" placeholder="Enter design number">
                        <small id="design-number-error" class="modal__error-message" style="color: red; display: none;">Invalid design number</small>
                    </div>

                    <!-- Hidden field for storing design type -->
                    <input type="hidden" id="design-type" name="design-type">


                    <div class="modal__buttons">
                        <button class="btn btn-primary modal__button publish mr-2" id="publish-button">Publish</button>
                        <button class="btn modal__button modal__close">Cancel</button>
                    </div>
                </div>
            </div>
            <div class="modal-overlay"></div>`;
};




  imageModal = (src) => {
    return `<div class="modal modal--image">
              <img src="${src}" alt="attachment" class="modal__image">
            </div>
            <span class="modal__close-icon">X</span>
            <div class="modal-overlay"></div>`;
  };

  cutcrop_modal = () => {
    return `<div class="modal cutcrop-modal">
                <div class="modal__heading-container">
                    <h3 class="modal__heading">Cut and Crop Image</h3>
                </div>
                <div class="modal__body">
                    <div class="cutcrop-container">
                        <img id="cutcrop-image" src="" alt="Image to crop" style="max-width: 100%; max-height: 600px;">
                    </div>
                    <div class="modal__buttons">
                        <button id="save-cropped-image" class="btn btn-primary modal__button modal__save mr-2">Save</button>
                        <a href="" class="btn modal__button modal__close">Cancel</a>
                    </div>
                </div>
            </div>
            <div class="modal-overlay"></div>`;
  };


  toggleModal = (e) => {
    if (e.target.classList.contains("archive")) {
      this.displayDeleteModal(e);
    } else if (e.target.classList.contains("share")) {
      this.displayShareModal(e);
    } else if (e.target.classList.contains("add-new")) {
      this.createNewProjectModal(e);
    } else if (e.target.classList.contains("rename")) {
      this.changeProjectName(e);
    } else if (e.target.classList.contains("duplicate")) {
      this.duplicateProject(e);
    } else if (e.target.classList.contains("duplicate-all")) {
      this.duplicateProjectAll(e);
    } else if (e.target.classList.contains("create-template")) {
      this.createTemplate(e);
    } else if (e.target.classList.contains("modal__close")) {
      this.isModalCloseButton(e);
    } else if (e.target.classList.contains("modal-overlay")) {
      this.isModalOverlay(e);
    } else if (e.target.classList.contains("modal__delete")) {
      this.isModalDeleteButton(e);
    } else if (e.target.classList.contains("modal__copy")) {
      this.isModalCopyButton(e);
    } else if (e.target.classList.contains("logout-modal")) {
      this.displayLogoutModal(e);
    } else if (e.target.classList.contains("cutcrop-modal")) {
      this.displayCutCropModal(e);
    }
  };

  displayDeleteAdditionalImageModal = () => {
    const div = document.createElement("div");
    div.innerHTML = this.delete_additional_image_modal();
    document.body.append(div);
  };

  displayShareModal = (e) => {
    if (!e.target.classList.contains("share")) {
      return false;
    }
    e.preventDefault();
    const projectId = e.target.parentElement.getAttribute("data-id");
    const div = document.createElement("div");
    div.innerHTML = this.share_modal(projectId);
    document.body.append(div);
    return true;
  };

  displayDeleteModal = (e) => {
    if (!e.target.classList.contains("archive")) {
      return false;
    }
    e.preventDefault();
    const projectId = e.target.parentElement.getAttribute("data-id");
    const div = document.createElement("div");
    div.innerHTML = this.delete_modal("project", "Project", projectId);
    document.body.append(div);
    return true;
  };

  createNewProjectModal = async (e) => {
    if (!e.target.classList.contains("add-new")) {
      return false;
    }
    e.preventDefault();
    const div = document.createElement("div");
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({ function: "get_projects", getCount: true })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    div.innerHTML = this.add_modal("Add", "", "", "", response);
    document.body.append(div);
    return true;
  };

  changeProjectName = (e) => {
    if (!e.target.classList.contains("rename")) {
      return false;
    }
    e.preventDefault();
    const name = e.target.getAttribute("data-name");
    const id = e.target.href.split("=")[1];
    const div = document.createElement("div");
    div.innerHTML = this.add_modal("Save", name, id);
    document.body.append(div);
    return true;
  };

  duplicateProject = (e) => {
    if (!e.target.classList.contains("duplicate")) {
      return false;
    }
    e.preventDefault();
    const id = e.target.getAttribute("data-id");
    const div = document.createElement("div");
    div.innerHTML = this.add_modal("Duplicate", "", id, "Duplicate project");
    document.body.append(div);
    return true;
  };

  duplicateProjectAll = (e) => {
    if (!e.target.classList.contains("duplicate-all")) {
      return false;
    }
    e.preventDefault();
    const id = e.target.getAttribute("data-id");
    const div = document.createElement("div");
    div.innerHTML = this.add_modal("Duplicate All", "", id, "Duplicate whole project");
    document.body.append(div);
    return true;
  };

  createTemplate = (e) => {
    if (!e.target.classList.contains("create-template")) {
      return false;
    }
    e.preventDefault();
    const id = e.target.getAttribute("data-id");
    const div = document.createElement("div");
    div.innerHTML = this.add_modal("Create template", "", id, "Create template");
    document.body.append(div);
    return true;
  };

  isModalCloseButton = (e) => {
    if (!e.target.classList.contains("modal__close")) {
      return false;
    }
    e.preventDefault();
    document.querySelector(".modal").parentElement.remove();
    return true;
  };
  isModalOverlay = (e) => {
    if (!e.target.classList.contains("modal-overlay")) {
      return false;
    }
    e.preventDefault();
    document.querySelector(".modal").parentElement.remove();
    return true;
  };
  isModalDeleteButton = async (e) => {
    if (!e.target.classList.contains("modal__delete")) {
      return false;
    }
    e.preventDefault();
    const id = e.target.getAttribute("data-id").split("=")[1];
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "delete_project",
        id,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    toastr_show("success", response["message"]);
    document
      .querySelectorAll(
        '.inner-page__layout-item[data-id="' +
          id +
          '"], .inner-page__layout-list-item[data-id="' +
          id +
          '"]'
      )
      ?.forEach((element) => {
        element.remove();
      });

    document.querySelector(".modal").parentElement.remove();
    return true;
  };
  isModalCopyButton = (e) => {
    if (!e.target.classList.contains("modal__copy")) {
      return false;
    }
    e.preventDefault();
    const copyText = document.querySelector(".modal__body-input");
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    if (navigation) {
      navigator?.clipboard?.writeText(copyText.value);
    } else {
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy text to clipboard:", err);
      }
    }
    return true;
  };


  
  displayProjectTypeModal = () => {
    const div = document.createElement("div");
    div.innerHTML = this.projectTypeModal();
    document.body.append(div);

    // Add event listener for dropdown selection change
    document.getElementById("selected-design-type").addEventListener("click", () => {
        document.getElementById("dropdown-select-items").classList.toggle("show");
    });

    // Attach event listener to input for real-time validation, only if user types
    const designNumberInput = document.getElementById("design-number");
    const manualInputContainer = document.getElementById("manual-input-container");

    designNumberInput.addEventListener("input", () => {
        if (designNumberInput.value.trim() === "") {
            // If empty, reset error message & allow publishing
            document.getElementById("design-number-error").style.display = "none";
            document.getElementById("publish-button").disabled = false;
        } else {
            this.validateDesignNumber();
        }
    });

    // Handle "Enter Design Number Manually" selection
    document.querySelectorAll(".dropdown-select__item").forEach(item => {
        item.addEventListener("click", () => {
            const selectedItem = document.getElementById("selected-design-type");
            const selectedDesignType = item.dataset.id;
            selectedItem.dataset.id = selectedDesignType;
            selectedItem.textContent = item.textContent;

            // If "Enter Design Number Manually" is selected, show the input field
            if (selectedDesignType === "manual") {
                manualInputContainer.style.display = "block";  // Show input field
                designNumberInput.disabled = false;  // Enable input field for manual entry
                this.validateDesignNumber();  // Validate after change
            } else {
                manualInputContainer.style.display = "none";  // Hide input field
                designNumberInput.disabled = true;  // Disable input field if not manually entering
                document.getElementById("design-number-error").style.display = "none";  // Hide error message
                document.getElementById("publish-button").disabled = false;  // Enable publish button
                document.getElementById("design-type").value = item.dataset.id;  // Set the design type
            }
        });
    });
};

// Updated validateDesignNumber function with a list of patterns
validateDesignNumber = () => {
    const designNumberInput = document.getElementById("design-number");
    const errorMessage = document.getElementById("design-number-error");
    const publishButton = document.getElementById("publish-button");
    const designTypeInput = document.getElementById("design-type");  // Hidden field for design type

    const designNumber = designNumberInput.value.trim();
    let isValid = false;
    let designType = ''; // Variable to hold the design type

    // List of regex patterns to validate design number
    const regexPatterns = [
        { pattern: /^1\d{5}$/, type: '1' },  // Forster Collection old (1xxxxx)
        { pattern: /^4\d{5}$/, type: '4' },  // Forster Orders old (4xxxxx)
        { pattern: /^T\d{5}$/, type: 'T' },  // Tests (T12345)
        { pattern: /^J\d{5}$/, type: 'J' },  // Jacob Schläpfer old (Jxxxxx)
        { pattern: /^1\d{6}$/, type: '1' },  // Forster Collection ERP-like (1xxxxxx)
        { pattern: /^4\d{6}$/, type: '4' },  // Forster Orders ERP-like (4xxxxxx)
        { pattern: /^T\d{6}$/, type: 'T' },  // Tests ERP-like (Txxxxxx)
        { pattern: /^J\d{6}$/, type: 'J' },  // Jacob Schläpfer ERP-like (Jxxxxxx)
        { pattern: /^7\d{5}$/, type: '7' },          // Forster Lace old (700000-799999)
        { pattern: /^2[0-4]\d{5}$/, type: '1' },     // Forster Kollektion new ERP (2000000-2499999)
        { pattern: /^2[5-9]\d{5}$/, type: '7' },     // Forster Lace new ERP (2500000-2999999)
        { pattern: /^3\d{6}$/, type: '4' }           // Forster Orders new ERP (3000000-3999999)
        // Jacob Schläpfer stays on legacy Jxxxxx numbers (no 7-digit ERP)
    ];

    // Only validate if "manual" option is selected and a design number is entered
    if (designNumber === "") {
        errorMessage.style.display = "none";
        publishButton.disabled = false;
        return;
    }

    // If "manual" option is selected, validate using all the regex patterns
    if (document.getElementById("selected-design-type").dataset.id === "manual") {
        // Check the design number against each pattern in the list
        for (let i = 0; i < regexPatterns.length; i++) {
            if (regexPatterns[i].pattern.test(designNumber)) {
                isValid = true;
                designType = regexPatterns[i].type;  // Assign matching design type
                break;  // Stop loop once a match is found
            }
        }
    }

    // Apply validation result
    if (isValid) {
        errorMessage.style.display = "none";
        publishButton.disabled = false;
        designTypeInput.value = designType;  // Set the design type in the hidden field
    } else {
        errorMessage.style.display = "block";
        publishButton.disabled = true;
        designTypeInput.value = '';  // Clear the design type if validation fails
    }
};






  displayImageModal = (src) => {
    const div = document.createElement("div");
    div.innerHTML = this.imageModal(src);
    document.body.append(div);
  };
  displayLogoutModal = (e) => {
    if (!e.target.classList.contains("logout-modal")) {
      return false;
    }
    e.preventDefault();
    const projectId = e.target.parentElement.getAttribute("data-id");
    const div = document.createElement("div");
    div.innerHTML = this.logout_modal(projectId);
    document.body.append(div);
    return true;
  };

  displayLeavingEditorModal = (e, goBack = false) => {
    e.preventDefault();
    const div = document.createElement("div");
    div.innerHTML = this.leave_editor(goBack);
    document.body.append(div);
    return true;
  };

  // Modify the displayCutCropModal function to accept the image URL
  displayCutCropModal = (imageUrl) => {
    const div = document.createElement("div");
    div.innerHTML = this.cutcrop_modal(); // No need for name/type/url as we're using image URL now
    document.body.append(div);

    // Initialize Cropper after the image is loaded
    const imageElement = document.getElementById("cutcrop-image");
    let cropper;

    imageElement.src = imageUrl; // Dynamically provide the image URL from the preview
    imageElement.onload = () => {
        cropper = new Cropper(imageElement, {
            aspectRatio: NaN, // No aspect ratio constraint
            viewMode: 0,      // No restrictions on the cropping area
            movable: true,     // Allow moving the crop box
            zoomable: true,    // Allow zooming in and out
            scalable: true,    // Allow scaling the image
            rotatable: true,   // Allow rotating the image
            autoCropArea: 1    // Initialize with maximum crop area
        });
    };

    // Handle Save button click for replacing the cropped image back to the preview and form
    document.getElementById("save-cropped-image").addEventListener("click", async () => {
        // Get the cropped canvas (use actual crop area dimensions)
        const croppedCanvas = cropper.getCroppedCanvas();

        // Convert the canvas to a Blob (image file)
        const croppedImageBlob = await new Promise((resolve) => {
            croppedCanvas.toBlob(resolve, "image/png");
        });

        // Convert the Blob to a data URL so we can replace the original image
        const croppedImageUrl = URL.createObjectURL(croppedImageBlob);

        // Find the image-preview element and replace its src with the cropped image
        const previewImageElement = document.querySelector(".image-preview");
        if (previewImageElement) previewImageElement.src = croppedImageUrl;

        // Now, add the cropped image to the file input element
        const fileInputElement = document.getElementById("fileInput");
        const croppedFile = new File([croppedImageBlob], "main.png", { type: "image/png" });

        // Create a new DataTransfer object to hold the file
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(croppedFile);

        // Assign the file to the file input
        fileInputElement.files = dataTransfer.files;

        // Close the modal after updating the image preview and form input
        document.querySelector(".modal").parentElement.remove();
    });
};




}
